"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _serializr = require("serializr");
var _mobx = require("mobx");
var _utils = require("@seedlang/utils");
var _lodash = require("lodash");
var _constants = require("@seedlang/constants");
var _exercise_entry_state = _interopRequireDefault(require("./exercise_entry_state"));
var _media_option = _interopRequireDefault(require("./media_option"));
var _multiple_choice_option = _interopRequireDefault(require("./multiple_choice_option"));
var _root_model = _interopRequireDefault(require("./root_model"));
var _sentence = _interopRequireDefault(require("./sentence"));
var _target = _interopRequireDefault(require("./target"));
var _video_clip = _interopRequireDefault(require("./video_clip"));
var _word = _interopRequireDefault(require("./word"));
var _word_association = _interopRequireDefault(require("./word_association"));
var _word_association_state = _interopRequireDefault(require("./word_association_state"));
var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17; // reminder to not import AppUI to avoid circular dependencies
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var ExerciseEntry = (_dec = (0, _serializr.serializable)((0, _serializr.list)((0, _serializr.object)(_word_association["default"]))), _dec2 = (0, _serializr.serializable)((0, _serializr.list)((0, _serializr.object)(_media_option["default"]))), _dec3 = (0, _serializr.serializable)((0, _serializr.list)((0, _serializr.object)(_multiple_choice_option["default"]))), _dec4 = (0, _serializr.serializable)((0, _serializr.object)(_word["default"])), _dec5 = (0, _serializr.serializable)((0, _serializr.object)(_target["default"])), _dec6 = (0, _serializr.serializable)((0, _serializr.object)(_sentence["default"])), _dec7 = (0, _serializr.serializable)((0, _serializr.object)(_video_clip["default"])), _class = /*#__PURE__*/function (_RootModel) {
  function ExerciseEntry(obj) {
    var _this;
    _classCallCheck(this, ExerciseEntry);
    _this = _callSuper(this, ExerciseEntry, [obj]);
    _initializerDefineProperty(_this, "id", _descriptor, _this);
    _initializerDefineProperty(_this, "position", _descriptor2, _this);
    _initializerDefineProperty(_this, "prompt", _descriptor3, _this);
    _initializerDefineProperty(_this, "extraWords", _descriptor4, _this);
    _initializerDefineProperty(_this, "firstWordIsLowercase", _descriptor5, _this);
    _initializerDefineProperty(_this, "instruction", _descriptor6, _this);
    _initializerDefineProperty(_this, "showSource", _descriptor7, _this);
    _initializerDefineProperty(_this, "grammarTip", _descriptor8, _this);
    _initializerDefineProperty(_this, "selectAllCorrectOptions", _descriptor9, _this);
    _initializerDefineProperty(_this, "keepOptionsInOrder", _descriptor10, _this);
    _initializerDefineProperty(_this, "wordAssociations", _descriptor11, _this);
    _initializerDefineProperty(_this, "mediaOptions", _descriptor12, _this);
    _initializerDefineProperty(_this, "multipleChoiceOptions", _descriptor13, _this);
    _initializerDefineProperty(_this, "word", _descriptor14, _this);
    _initializerDefineProperty(_this, "target", _descriptor15, _this);
    _initializerDefineProperty(_this, "sentence", _descriptor16, _this);
    _initializerDefineProperty(_this, "videoClip", _descriptor17, _this);
    _this.state = new _exercise_entry_state["default"](_this);
    return _this;
  }
  _inherits(ExerciseEntry, _RootModel);
  return _createClass(ExerciseEntry, [{
    key: "shuffledMediaOptions",
    get: function get() {
      if (this.keepOptionsInOrder) {
        return (0, _mobx.toJS)(this.mediaOptions);
      }
      return (0, _lodash.shuffle)((0, _mobx.toJS)(this.mediaOptions));
    }
  }, {
    key: "multipleChoiceOptionsWithText",
    get: function get() {
      return this.multipleChoiceOptions.filter(function (item) {
        return (0, _utils.isPresent)(item.targetText);
      });
    }
  }, {
    key: "shuffledMultipleChoiceOptions",
    get: function get() {
      if (this.keepOptionsInOrder) {
        return (0, _mobx.toJS)(this.multipleChoiceOptionsWithText);
      }
      return (0, _lodash.shuffle)((0, _mobx.toJS)(this.multipleChoiceOptionsWithText));
    }
  }, {
    key: "hasSentence",
    get: function get() {
      return (0, _utils.isPresent)(this.sentence);
    }
  }, {
    key: "hasMediaOptions",
    get: function get() {
      return (0, _utils.isPresent)(this.mediaOptions) && this.mediaOptions.length > 1;
    }
  }, {
    key: "hasMultipleChoiceOptions",
    get: function get() {
      return (0, _utils.isPresent)(this.multipleChoiceOptions);
    }
  }, {
    key: "wordAssociationsWithExtraWords",
    get: function get() {
      var _this2 = this;
      var extraWords = (0, _utils.isPresent)(this.extraWords) ? this.extraWords.split(',') : [];
      extraWords = extraWords.map(function (item) {
        return {
          id: item,
          adjustedTargetText: item,
          targetText: item,
          state: new _word_association_state["default"](_this2)
        };
      });
      return (0, _lodash.shuffle)(extraWords.concat(this.sentence.selectedWordAssociations));
    }
  }, {
    key: "languageId",
    get: function get() {
      var _this$sentence, _this$word;
      return ((_this$sentence = this.sentence) === null || _this$sentence === void 0 ? void 0 : _this$sentence.languageId) || ((_this$word = this.word) === null || _this$word === void 0 ? void 0 : _this$word.languageId);
    }
  }, {
    key: "numberOfCorrectOptions",
    get: function get() {
      if (this.multipleChoiceOptions.length > 0) {
        return this.multipleChoiceOptions.filter(function (item) {
          return item.correct;
        }).length;
      }
      if (this.mediaOptions.length > 1) {
        return this.mediaOptions.filter(function (item) {
          return item.selected;
        }).length;
      }
      return 0;
    }
  }, {
    key: "warningMessages",
    get: function get() {
      if (!this.state.correct) {
        return [];
      }
      var messages = [];
      if (this.state.incorrectCasing) {
        messages.push("".concat(_constants.Constants.WARNINGS['letterCase'], " You wrote <i>").concat(this.state.incorrectCasingSubmittedValue, "</i>"));
      }
      if (this.state.incorrectSpecialCharacters) {
        messages.push("".concat(_constants.Constants.WARNINGS['accents'], " You wrote <i>").concat(this.state.incorrectSpecialCharactersSubmittedValue, "</i>"));
      }
      if (this.state.incorrectPunctuation) {
        messages.push("".concat(_constants.Constants.WARNINGS['punctuation'], " You wrote <i>").concat(this.state.incorrectPunctuationSubmittedValue, "</i>"));
      }
      return messages;
    }
  }, {
    key: "promptIsEnglishTranslation",
    get: function get() {
      return (0, _utils.isPresent)(this.prompt) && !this.showSource;
    }
  }]);
}(_root_model["default"]), _descriptor = _applyDecoratedDescriptor(_class.prototype, "id", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "position", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "prompt", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "extraWords", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "firstWordIsLowercase", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "instruction", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "showSource", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "grammarTip", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "selectAllCorrectOptions", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "keepOptionsInOrder", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "wordAssociations", [_mobx.observable, _dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "mediaOptions", [_mobx.observable, _dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "multipleChoiceOptions", [_mobx.observable, _dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "word", [_mobx.observable, _dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "target", [_mobx.observable, _dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "sentence", [_mobx.observable, _dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "videoClip", [_mobx.observable, _dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _applyDecoratedDescriptor(_class.prototype, "shuffledMediaOptions", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "shuffledMediaOptions"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "multipleChoiceOptionsWithText", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "multipleChoiceOptionsWithText"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "shuffledMultipleChoiceOptions", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "shuffledMultipleChoiceOptions"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasSentence", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasSentence"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasMediaOptions", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasMediaOptions"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasMultipleChoiceOptions", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasMultipleChoiceOptions"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "wordAssociationsWithExtraWords", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "wordAssociationsWithExtraWords"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "languageId", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "languageId"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "numberOfCorrectOptions", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "numberOfCorrectOptions"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "warningMessages", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "warningMessages"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "promptIsEnglishTranslation", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "promptIsEnglishTranslation"), _class.prototype), _class);
var _default = exports["default"] = ExerciseEntry;